import styled from 'styled-components';

export default styled.button`
  background: none;
  border: none;
  color: #777;
  cursor: pointer;
  font-size: 20px;
  outline: none;
  position: absolute;
  right: 10px;
  top: 10px;
  transition: transform 0.1s ease-in-out;

  @media (max-width: 600px) {
    right: 12px;
    top: 12px;
  }

  &:hover {
    transform: scale(1.1);
  }
`;
